
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import CustomDialog from '../commoncomponents/CustomDialog';
import dayjs from "dayjs";
import { useDispatch, useSelector } from 'react-redux';
import { addRepairTrackerForVendor, clearRepairTrackerForVendor, updateCompletionInfoDetails, updateothereRespondedDetails, updateRespondDetails } from '../../redux/actions/vendor/webFormActions';
import { getAuthToken, getCreatedBy } from '../../utility/tokenUtility';
import { DefaultCard } from '../../assets/styled-components/card';
import CustomDateTimePicker from '../commoncomponents/CustomDateTimePicker';
import CustomTextArea from '../commoncomponents/CustomTextArea';
import SCMRespondedDetailsEditForm from './SCMRespondedDetailsEditForm';
import SCMOtherRespondedDetailsEditForm from './SCMOtherRespondedDetailsEditForm';
import SCMRepairTrackerEditForm from './SCMRepairTrackerEditForm';
import SCMPartReplacementEditForm from './SCMPartReplacementEditForm';
import ScmBottomButtonsforWorkOrder from '../scmcomponents/ScmBottomButtonsforWorkOrder';
import BottomButtonForSCMVendorForm from './BottomButtonForSCMVendorForm';
import BottomButtonForVendor from '../vendordashboard/BottomButtonForVendor';
import { processingPercentageValue, statusList } from '../../utility/message';
import ScmRepositry from '../../api/repositories/scmRepository';
import { scmAddRepairTrackerForVendor, scmCheckFormSubmitForVendor, scmClearRepairTrackerForVendor, scmUpdateCompletionInfoDetails, scmUpdateothereRespondedDetails } from '../../redux/actions/vendor/scmWebFormActions';
import { useLocation } from 'react-router-dom';

const SCMVendorWorkOrderEditForm = ({ setPage, buttonAttributes, page, locationState }) => {

    const createdBy = getCreatedBy('createdBy');
    const token = getAuthToken("id_token");
    const location = useLocation();
    const [responseData, setResponseData] = useState(null);
    const webFormData = useSelector((state) => state.scmVendorWebForm);
    const [otherDetails, setOtherDetails] = useState(webFormData?.otherRespondedDeatils);
    const [repairTrackerRows, setRepairTrackerRows] = useState(webFormData?.repairTracker);
    const [partReplacementGridRows,setPartReplacementGridRows] = useState(webFormData?.partReplacementRows)
    const [openDialog, setOpenDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const [completionData, setCompletionData] = useState(webFormData?.completionDetails);
    const [error, setError] = useState({
        actionTaken: false,
        startDateandTime:false,
        endDateandTime:false,
        repairTrackerRows:false,
        outsourceRespondRemarks:false
    });
    const [errorMessage, setErrorMessage] = useState({
        actionTaken: "",
        startDateandTime:"",
        endDateandTime:"",
        repairTrackerRows:"",
        outsourceRespondRemarks:""
    });

    const workOrderId = locationState?.workorderId || "";
    const assetCategroyType = locationState?.serviceType || "";
    const categoryType = locationState?.categoryType || "";
    const serviceType = assetCategroyType === "FEMS" ? "fem" : "bem";
    const getRepairTrackerRows = webFormData?.repairTracker || [];
    const getstatusId = webFormData?.workderStatus || "";
    const checkstatus = [statusList?.completed?.id,statusList?.completedOutsource?.id,statusList?.closed?.id,statusList?.verified?.id].includes(getstatusId) ? true : false;
    const isViewMode = locationState?.isViewMode;

    const handleOnchange = (value, name,) => {
        setCompletionData((previous) => {
            const updatedData = {
                ...previous,
                [name]: value,
            };

            return updatedData;
        });

        if (name === 'actionTaken' && value.trim()) {
            setError((prevError) => ({ ...prevError, actionTaken: false }));
            setErrorMessage((prevMessage) => ({ ...prevMessage, actionTaken: "" }));
        }

        let workorderDateandTime = responseData[0]?.[`${serviceType}schcorrectivemaintenanceheaders`][0]?.workorderdate || ''
        const workOrderDateAndTime = new Date(workorderDateandTime);
        const selectedDate = new Date(value);
        const currentDate = new Date();
        const endDate = new Date(completionData?.endDateandTime);
    
        if (name === 'startDateandTime' && value) {
    
          if (selectedDate < workOrderDateAndTime || selectedDate > currentDate) {
            setError((prevErrors) => ({
              ...prevErrors,
              startDateandTime: true,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              startDateandTime: "Start date and time should be between Work Order date and current date/time.",
            }));
          } else {
            setError((prevErrors) => ({
              ...prevErrors,
              startDateandTime: false,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              startDateandTime: "",
            }));
          }
    
          if (endDate && selectedDate) {
            if (selectedDate >= endDate) {
              setError((prevErrors) => ({
                ...prevErrors,
                endDateandTime: true,
              }));
              setErrorMessage((prevErrorMessages) => ({
                ...prevErrorMessages,
                endDateandTime: "End date and time should be on the same day and greater than the start time.",
              }));
            } else {
              setError((prevErrors) => ({
                ...prevErrors,
                endDateandTime: false,
              }));
              setErrorMessage((prevErrorMessages) => ({
                ...prevErrorMessages,
                endDateandTime: "",
              }));
            }
          };
        };
    
        if (name === 'endDateandTime' && value) {
          const selectedEndDateTime = new Date(value);
          const startDateTime = new Date(completionData?.startDateandTime);
          if (
            selectedEndDateTime.toDateString() !== startDateTime.toDateString() || // If the dates are not the same
            selectedEndDateTime < startDateTime ||
            selectedEndDateTime > currentDate
          ) {
            setError((prevErrors) => ({
              ...prevErrors,
              endDateandTime: true,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              endDateandTime: "End date and time should be on the same day and greater than the start time.",
            }));
          } else {
            setError((prevErrors) => ({
              ...prevErrors,
              endDateandTime: false,
            }));
            setErrorMessage((prevErrorMessages) => ({
              ...prevErrorMessages,
              endDateandTime: "",
            }));
          };
        };


    };

    useEffect(() => {
        const fetchData = async () => {
            if (workOrderId) {

                const response = await ScmRepositry.getWorkOrderSummary(serviceType, workOrderId);
                console.log(response,"response");
                
                setResponseData(response);
                const updateCompletionData = {
                    completionId: response[0]?.[`${serviceType}schcorrectivemaintenanceheaders`][0]?.[`${serviceType}schcorrectivecompletiondetails`][0]?.id || "",
                    // startDateandTime: response[0]?.[`${serviceType}schcorrectivemaintenanceheaders`][0]?.[`${serviceType}schcorrectivecompletiondetails`][0]?.startdate || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                    // endDateandTime: response[0]?.[`${serviceType}schcorrectivemaintenanceheaders`][0]?.[`${serviceType}schcorrectivecompletiondetails`][0]?.enddate || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                    actionTaken: response[0]?.[`${serviceType}schcorrectivemaintenanceheaders`][0]?.[`${serviceType}schcorrectivecompletiondetails`][0]?.actiontaken || response?.[0]?.scheduledActionTaken || "",
                    timeStamp: response[0]?.[`${serviceType}schcorrectivemaintenanceheaders`][0]?.[`${serviceType}schcorrectivecompletiondetails`][0]?.timestamp || ""
                };
                setCompletionData(updateCompletionData);
                dispatch(updateCompletionInfoDetails("UPDATE_COMPLETION_DETAILS", updateCompletionData));
            }
        };
        fetchData();


    }, [serviceType, workOrderId]);    

    const handleSaveClick = useCallback(async (event) => {
        event.preventDefault();

        let hasError = false;
        // if(!(locationState?.isViewMode)){
        if(!(isViewMode || checkstatus)){

        if (!completionData?.actionTaken.trim()) {
            setError((prevError) => ({ ...prevError, actionTaken: true }));
            setErrorMessage((prevMessage) => ({ ...prevMessage, actionTaken: "Action Taken is required." }));
            hasError = true;
        }
        // Check if otherDetails.outsourceRespondRemarks is empty or not
        if (!otherDetails?.outsourceRespondRemarks.trim()) {
            setError((prevError) => ({ ...prevError, outsourceRespondRemarks: true }));
            setErrorMessage((prevMessage) => ({ ...prevMessage, outsourceRespondRemarks: "Outsource Respond Remarks is required." }));
            hasError = true;
        }

        // Check if there are any errors related to dates or outsourceRespondRemarks
        if (error?.startDateandTime || error?.endDateandTime || error?.outsourceRespondRemarks) {
            hasError = true;
        }

        // Check if there are repair tracker rows
        if (repairTrackerRows <= 0) {
            setError((prev) => ({
                ...prev,
                repairTrackerRows: true,
            }));
            setErrorMessage((prev) => ({
                ...prev,
                repairTrackerRows: "Please add at least one repair tracker row.",
            }));
            hasError = true;
        }

        // If there are any errors, return early
        if (hasError) {
            return;
        }

        const sendTheStatusID = webFormData?.workderStatus === statusList?.inProgress?.id ?  statusList?.inProgressOutsource?.id : webFormData?.workderStatus; //Send the status ID
        const sendCategoryID = locationState?.categoryId ? locationState?.categoryId : categoryType === "UnScheduled" ? 1 : 2;
        const sendProcessingPercentage = processingPercentageValue?.assessmentTab; // Send the proceesing percentage value for assements tab

        const APIPayload = {
            respondedbyid:webFormData?.respondedDetails?.respondedByID || "",
            responsestartdate: webFormData?.respondedDetails?.respondedStartDateandTime || "",
            responseenddate: webFormData?.respondedDetails?.respondedEndDateandTime || "",
            assessmenthrs: "",
            respondedByName: "",
            respondfinding: otherDetails?.respondFinding || "",
            ispartsrequired:  otherDetails.selectedPartsRequired ? (otherDetails.selectedPartsRequired === "yes" ? true : false) : "",
            isassettakenoutlocation: otherDetails.selectedAssetTakenOut ? (otherDetails.selectedAssetTakenOut === "yes" ? true : false) : "",
            vendorid: webFormData?.respondedDetails?.vendorID || "",
            Respondremarks: otherDetails?.outsourceRespondRemarks || "",
            [`${serviceType}schcorrectivemaintenanceheaderId`]: workOrderId || "",
            [`${serviceType}taskdetailsId`]: webFormData?.respondedDetails?.taskCodeID || "",
            [`${serviceType}worespondtypeId`]: webFormData?.respondedDetails?.repairTypeID || "",
            token:token
          };
          

        const updateAssessmentsPayload = {
            assessmentId: otherDetails.assessmentId || "",
            ispartsrequired: otherDetails.selectedPartsRequired
                ? (otherDetails.selectedPartsRequired === "yes" ? true : false)
                : "",
            isassettakenoutlocation: otherDetails.selectedAssetTakenOut
                ? (otherDetails.selectedAssetTakenOut === "yes" ? true : false)
                : "",
            respondremarks: otherDetails.outsourceRespondRemarks,
            category: 3, //For SCM send id:3 for Backend Reference,
            workorderheaderId: workOrderId || "",
            workorderstatusId: statusList?.inProgressOutsource?.id || "",
            processingpercentage: processingPercentageValue?.assessmentTab || "",
        };

        const UpdateCompletionPayload = {
            startdate: completionData.startDateandTime || "",
            enddate: completionData.endDateandTime || "",
            actiontaken: completionData.actionTaken || "",
            [`${serviceType}schcorrectivemaintenanceheaderId`]: workOrderId || "",
            id: completionData?.completionId || "",
            timestamp: completionData?.timeStamp || ""
        };

        const employeeName = await ScmRepositry.fetchEmployeeDetails();
        const lovOptions = await ScmRepositry.lovOptions();
        const mapEmpCode = (id) => {
            const empCode = employeeName?.find(empc => empc.id === id);
            return empCode ? empCode.employeecode : '';
        };

        const mapEmpName = (id) => {
            const empCode = employeeName?.find(empN => empN.id === id);
            return empCode ? empCode.employeename : '';
        };

        const mapFlagDesc = (id) => {
            const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
            return flagDesc ? flagDesc?.repairflag : '';
        };
        
        const mapPicDesc = (id) => {
            const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
            return picDesc ? picDesc?.repairpic : '';
        };

        const mapActivityDesc = (id) => {
            const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
            return activityDesc ? activityDesc?.repairactivity : '';
        };

        	const updatePayload = partReplacementGridRows?.map((row) => ({
			itemcodeid: row?.itemPartCode?.id || "",
			quantityused: row?.quantity,
			partscost: row?.partCost,
			[`${serviceType}schcorrectivemaintenanceheaderId`]: row?.[`${serviceType}schcorrectivemaintenanceheaderId`],
			createdby: createdBy,
			[`${serviceType}schcorrectivemaintenanceheaderId`]: workOrderId,
			id: row?.id || "",
			timestamp: row?.timeStamp || ""
		}));

        try {

            let assementsResponse = [];
            if(otherDetails?.assessmentId){                
                assementsResponse = await ScmRepositry.updateAssessmentsDetailsInWebForm(serviceType,updateAssessmentsPayload);
            } else {
                assementsResponse = await ScmRepositry?.addAssessmentsDetails(serviceType,APIPayload)
            };

            const assementsID = otherDetails?.assessmentId ||assementsResponse?.id || "";

            const updaterRepairDetailsPayload = repairTrackerRows?.map((row) => ({
                employeeid: row?.employeename?.id || "",
                Vendortechnician: row?.technician || "",
                repairstartdate: row?.startDateandTime || "",
                repairenddate: row?.endDateandTime || "",
                repairduration: row?.repairDuration || "",
                preparationhours: row?.preparationHours || "",
                verificationhours: row?.verificationHours || "",
                remarks: row?.remarks || "",
                [`${serviceType}schcorrectivemaintenanceheaderId`]: workOrderId || "",
                [`${serviceType}schcorrectiveassessmentheaderId`]: assementsID || otherDetails.assessmentId || "",
                [`${serviceType}uschworepairflagId`]: row?.flag?.id || "",
                [`${serviceType}uschworepairpicId`]: row?.pic?.id || "",
                [`${serviceType}uschworepairactivityId`]: row?.activity?.id || "",
                createdby: createdBy,
                id: row?.id || "",
                timestamp: row?.timeStamp || ""
            }));

            const saveRepairTracker = await ScmRepositry.updateRepairTracker(serviceType, updaterRepairDetailsPayload, assementsID);
            dispatch(scmClearRepairTrackerForVendor("SCM_CLEAR_REPAIR_TRACKER_FOR_VENDOR", []));
            saveRepairTracker?.forEach((row) => {
                const transformedObject = {
                    employeename: {
                        employeeCode: mapEmpCode(row?.employeeid || ""),
                        employeename: mapEmpName(row?.employeeid || ""),
                        id: row?.employeeid || "",
                    },
                    flag: {
                        id: row?.[`${serviceType}uschworepairflagId`] || "",
                        label: mapFlagDesc(row?.[`${serviceType}uschworepairflagId`] || "")
                    },
                    pic: {
                        id: row?.[`${serviceType}uschworepairpicId`] || "",
                        label: mapPicDesc(row?.[`${serviceType}uschworepairpicId`] || "")
                    },
                    activity: {
                        id: row?.[`${serviceType}uschworepairactivityId`] || "",
                        label: mapActivityDesc(row?.[`${serviceType}uschworepairactivityId`] || "")
                    },
                    Vendortechnician: row?.technician || row?.vendortechnician || "",
                    startDateandTime: row?.repairstartdate || "",
                    endDateandTime: row?.repairenddate || "",
                    repairDuration: row?.repairduration || "",
                    preparationHours: row?.preparationhours || "",
                    verificationHours: row?.verificationhours || "",
                    remarks: row?.remarks || "",
                    id: row?.id || "",
                    timeStamp: row?.timestamp || ""
                };
                
                dispatch(scmAddRepairTrackerForVendor("SCM_ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR", transformedObject));
            });

            if (updatePayload?.length > 0) {
                		const addItemPartCode = await ScmRepositry.updateItemPartCode(serviceType, updatePayload, workOrderId);
                		dispatch({ type: "CLEAR_PART_REPLACEMENT_FOR_VENDOR", payload: [] });
                		const itemCodeResponse = await ScmRepositry.fetchItemCodeoptions(serviceType, categoryType);
                		const mapItemCode = (id) => {
                			const ic = itemCodeResponse.find(ic => ic.id === id);
                			return ic ? ic.itemcode : '';
                		};
            
                		const mapItemDesc = (id) => {
                			const ic = itemCodeResponse.find(ic => ic.id === id);
                			return ic ? ic.descriptionname : '';
                		};
            
                		addItemPartCode?.forEach((row) => {
                			const transformedObject = {
                				itemDescription: mapItemDesc(row?.itemcodeid || ""),
                				itemPartCode: {
                					id: row?.itemcodeid || "",
                					label: mapItemCode(row?.itemcodeid || "")
                				},
                				partCost: row?.partscost || 0,
                				quantity: row?.quantityused || 0,
                				id: row?.id || "",
                				timeStamp: row?.timestamp || ""
                			};
            
                			dispatch({ type: "PART_REPLACEMENT_FOR_VENDOR", payload: transformedObject });
                		});
                	};

            if (completionData?.completionId) {
                const updCompletionInfo = await ScmRepositry.updateCompletionInfo(serviceType, completionData?.completionId, UpdateCompletionPayload);
                dispatch(scmUpdateCompletionInfoDetails("SCM_UPDATE_COMPLETION_DETAILS", { ...completionData, completionId: updCompletionInfo?.id, timeStamp: updCompletionInfo?.timestamp || "" }));

            } else {
                const saveCompletionInfo = await ScmRepositry.addCompletionInfo(serviceType, UpdateCompletionPayload);
                ScmRepositry.workorderStatusValue(serviceType, workOrderId, statusList?.inProgressOutsource?.id, processingPercentageValue?.assessmentTab, categoryType === "UnScheduled" ? 1 : 2);
                dispatch(scmUpdateCompletionInfoDetails("SCM_UPDATE_COMPLETION_DETAILS", { ...completionData, completionId: saveCompletionInfo?.id, timeStamp: saveCompletionInfo?.timestamp || "" }));
                dispatch(scmCheckFormSubmitForVendor("SCM_UPDATE_FORMSUBMIT_STATUS", statusList?.inProgressOutsource?.id));
            
            }

            dispatch(scmUpdateothereRespondedDetails("SCM_UPDATE_OTHER_RESPONDED_DETAILS", otherDetails));


        } catch (error) {
            console.error('Error saving data:', error);
        }
    }
        setPage('Attachments & Signature');
    }, [repairTrackerRows, otherDetails, workOrderId, completionData]);

    useEffect(() => {

        const loadData = async () => {
            setIsLoading(true);
            // Update states
            setRepairTrackerRows(webFormData?.repairTracker);
            setOtherDetails(webFormData?.otherRespondedDeatils || otherDetails);
            setPartReplacementGridRows(webFormData?.partReplacementRows);
            if(webFormData?.repairTracker?.length > 0){
                setError((prev) => ({
                ...prev,
                repairTrackerRows: false,
                }));
        
                setErrorMessage((prev)=>({
                ...prev,
                repairTrackerRows:""
                }))
            }
            setIsLoading(false);
        };

        loadData();

        if(getRepairTrackerRows?.length > 0){
            let getFirstIndexofStartDateTime;
            let getLastIndexofEndDateTime;
    
            if (getRepairTrackerRows?.length === 1) {
                getFirstIndexofStartDateTime = getRepairTrackerRows[0]?.startDateandTime || "";
                getLastIndexofEndDateTime = getRepairTrackerRows[0]?.endDateandTime || "";
            } else if (getRepairTrackerRows?.length > 1) {
                getFirstIndexofStartDateTime = getRepairTrackerRows?.reduce((earliest, current) => {
                return new Date(earliest?.startDateandTime) < new Date(current?.startDateandTime) ? earliest : current;
                })?.startDateandTime || "";
                // Find the row with the greatest endDateandTime
                getLastIndexofEndDateTime = getRepairTrackerRows.reduce((latest, current) => {
                return new Date(latest?.endDateandTime) > new Date(current?.endDateandTime) ? latest : current;
                })?.endDateandTime || "";
            
                getLastIndexofEndDateTime = getLastIndexofEndDateTime || "";
            };

            setCompletionData((prev)=>({
                ...prev,
                startDateandTime: getFirstIndexofStartDateTime || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                endDateandTime: getLastIndexofEndDateTime || dayjs().format("YYYY-MM-DDTHH:mm:ss")
            }));
        };

    }, [webFormData,getRepairTrackerRows,completionData?.startDateandTime,completionData?.endDateandTime]);

     useMemo(()=>{
            if(otherDetails?.outsourceRespondRemarks){
                setError((prev)=>({
                    ...prev,
                    outsourceRespondRemarks:false
                }));
    
                setErrorMessage((prev)=>({
                    ...prev,
                    outsourceRespondRemarks:""
                }));
            }
    
        },[otherDetails?.outsourceRespondRemarks])

    const handleCloseSuccessDialog = () => {
        setOpenDialog(false);
    };

    return (
        <>
            <form onSubmit={handleSaveClick} noValidate >
                <SCMRespondedDetailsEditForm locationState={locationState} responseData={responseData?.[0]} />
                <Box mb={2} />

                <SCMOtherRespondedDetailsEditForm
                    locationState={locationState}
                    responseData={responseData?.[0]}
                    onOtherDetailsChange={setOtherDetails}
                    errorState={error?.outsourceRespondRemarks}
                    errorMesaage={errorMessage?.outsourceRespondRemarks || ""}
                />
                <Box mb={2} />
                <DefaultCard>

                {error?.repairTrackerRows && (
                                        <Typography component={"span"} color={"error"}>
                                            {errorMessage?.repairTrackerRows}*
                                        </Typography>
                                    )}
                <SCMRepairTrackerEditForm
                    locationState={locationState}
                    responseData={responseData?.[0]}
                />
                </DefaultCard>
                <Box mb={2} />

                {/* {otherDetails?.selectedPartsRequired === "yes" && 
                    (<>
                        <SCMPartReplacementEditForm
                            locationState={locationState}
                            responseData={responseData?.[0]}
                        />
                        <Box mb={2}/>
                    </>)
                } */}
                <DefaultCard>
                    <Box >
                        <Typography variant='title2' gutterBottom>
                            Completion Info
                        </Typography>
                        <Box mb={3} />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <CustomDateTimePicker
                                    label="Start Date and Time"
                                    onDateChange={(date) => handleOnchange(date, 'startDateandTime')}
                                    value={completionData?.startDateandTime}
                                    error={error?.startDateandTime}
                                    helperText={errorMessage?.startDateandTime || ""}
                                    // disabled={isViewMode || checkstatus}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomDateTimePicker
                                    label="End Date and Time"
                                    onDateChange={(date) => handleOnchange(date, 'endDateandTime')}
                                    value={completionData?.endDateandTime}
                                    error={error?.endDateandTime}
                                    helperText={errorMessage?.endDateandTime || ""}
                                    disabled={isViewMode || checkstatus}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomTextArea
                                    label="Action Taken"
                                    id="actionTaken"
                                    name="actionTaken"
                                    onChange={(e) => handleOnchange(e, "actionTaken")}
                                    value={completionData?.actionTaken || ''}
                                    error={error?.actionTaken}
                                    helperText={errorMessage?.actionTaken}
                                    isMandatoryField={true}
                                    // disabled={isViewMode || checkstatus}
                                    disabled={true}

                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DefaultCard>
                {locationState?.bottomButtons && <BottomButtonForVendor page={page} buttonAttributes={buttonAttributes} />}
                {!locationState?.bottomButtons && <BottomButtonForSCMVendorForm page={page} buttonAttributes={buttonAttributes} />}

                <CustomDialog
                    open={openDialog}
                    onClose={handleCloseSuccessDialog}
                    title="Success"
                    confirmBtn="Ok"
                    content="Data updated successfully."
                />
            </form>
        </>
    );
};

export default SCMVendorWorkOrderEditForm;
